import React ,{ Suspense, lazy }from 'react'

import "@fontsource/mulish";
import Homepage from "./pages/index";
import Header  from './components/Header';
import { HelmetProvider } from 'react-helmet-async';
import { Routes, BrowserRouter as Router, Route } from "react-router-dom";
import {useEffect} from 'react';
import { pageViewEvent } from "./services/adobeDataLayer";

import Thankyou from "./pages/thankyou";

function App() {

  useEffect(() => {
    pageViewEvent("landing page");
  }, [])
  
  return (
    <>
      <HelmetProvider>
        <Router basename={window.location.pathname}>
        <Header path="./dist/img/logo.webp" />
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/thankyou" element={<Thankyou />} />
          </Routes>
        </Router>
      </HelmetProvider>

    </>
  );
}

export default App;
